import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import "./Topbar.css";
// import servizyLogo from "../../assets/servizy-logo.png";

const Topbar = ({ toggleSidebar }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const adminDisplayName = "Admin";

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("adminUser");
    navigate("/admin/login", { replace: true });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="topbar">
      {/* LEFT */}
      <button className="menu-btn" onClick={toggleSidebar}>
        <Menu size={24} />
      </button>

      {/* CENTER LOGO */}
      {/* <div className="topbar-brand">
        <img src={servizyLogo} alt="logo" className="topbar-logo" />
      </div> */}

      {/* RIGHT */}
      <div className="right-section">
        <div className="profile-container" ref={dropdownRef}>
          <div className="user-avatar" onClick={() => setOpen(!open)}>
            {adminDisplayName}
          </div>

          {open && (
            <div className="dropdown">
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Topbar;